<template>
  <div class="city-submit" :class="{'city-submit_hidden':!showCityConfirm}" :style="showCityConfirm ? 'opacity:1;' : 'opacity:0' ">
    <span class="city-submit__triangle"></span>
    <div class="city-submit__wrapper">
      <div>
        <span class="city-submit__text">Это ваш город?</span>
        <div class="city-submit__buttons">
          <b-button class="button_green" @click="submitConfirmCity">Да</b-button>
          <b-button class="button_red" @click="showCitySelect">Выбрать другой</b-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CitySubmit',
  props: {
    showCityConfirm: Boolean,
    showCitySelect: Function,
    submitConfirmCity: Function,
  },
  data() { return { }; },
};
</script>

<style scoped lang="scss">
  .city-submit {
    background: #FFF;
    border: 1px solid #E2E2E2;
    box-sizing: border-box;
    box-shadow: 5px 5px 20px rgba(34, 34, 24, 0.133464);
    border-radius: 3px;
    position: absolute;
    top: 34px;
    right: 0;
    z-index: 10;
    width: 282px;

    transition: opacity 200ms;
  }

  .city-submit__text {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
    margin-bottom: 10px;
    display: block;
  }

  .city-submit__wrapper {
    padding: 12px 19px 15px;
    position: relative;
    background-color: #FFF;
    z-index: 10;
  }

  .city-submit__triangle {
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 12px 14px 12px;
    border-color: transparent transparent #e2e2e2 transparent;
    position: absolute;
    top: -8px;
    right: 15px;

    &:after {
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 12px 14px 12px;
      border-color: transparent transparent #fff transparent;
      position: absolute;
      top: 1px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .city-submit__buttons {
    white-space: nowrap;

    button {

      &:first-child {
        margin-right: 12px;
      }

      cursor: pointer;
      display: inline-block;
      vertical-align: top;
      text-align: center;
      border: none;
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #FFFFFF;
      padding: 9px 21px;

      &:hover {
        opacity: .6;
      }

      &:active {
        opacity: .8;
      }
    }

    .button_green {
      background: #A6CE39;
      border-radius: 4px;
    }

    .button_red {
      background: #ED1651;
      border-radius: 4px;
    }
  }

  .city-submit_hidden {
    position: absolute;
    top: -1000px;
    left: -1000px;
  }

</style>
